module.exports = __webpack_public_path__ + "img/CosmEthically-ACTIVE-Journal.ef0951e2.png";